<div id="cont">
    <mat-slide-toggle [checked]="checked"
                      (change)="change.emit($event.checked)">
    </mat-slide-toggle>
    <div id="infos">
        <span *ngIf="checked">{{'GENERATE_LOCATION_WITH_DEVICE' | translate}}</span>
        <span *ngIf="!checked">{{'NOT_GENERATE_LOCATION_WITH_DEVICE' | translate}}</span>
    </div>
</div>
